/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Modal, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { CalendarModal } from "../../../sub-modules";
import { useLocation, useNavigate } from "react-router-dom";
import { SelectedSlotType } from "../../../utilities/types";
import { format } from "date-fns";
import { rescheduleAmount, rescheduleCourtBookingApi } from "../../../utilities/api/courtBooking";
import { ToastContainer, toast } from "react-toastify";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { CheckReschedule, LableFromEnums } from "../../../utilities";
import { GetFilterdCourt } from "../../../utilities/api/courts";


const RescheduleCourtBooking = () => {
    const location = useLocation().state
    const navigate = useNavigate()
    const { name } = useAppSelector(state => state.verifiedUser.UserRole?.role)
    const { Enums } = useAppSelector((state) => state.enumsArray);
    const [show, setShow] = useState(false);
    const [openPaynow, setOpenPaynow] = useState(false);
    const [selectedSlots, setSelectedSlots] = useState<SelectedSlotType[]>([])
    const [rescheduleSlot, setRescheduleSlot] = useState<SelectedSlotType[]>([])
    const [editDate, setEditDate] = useState(format(new Date(), "dd-MM-yyyy"))
    const [reviseAmount, setReviseAmount] = useState({}) as any
    const [paymentMode, setPaymentMode] = useState("")
    const [paymentMethod, setPaymentMethod] = useState("")
    const [cancelSlots, setCancelSlots] = useState<number[]>([])
    const [rescheduleButton, setRescheduleButton] = useState(false)
    const [courtList, setCourtList] = useState<any>([])

    const handleClose = () => {
        setShow(false);
        setOpenPaynow(false);
        setSelectedSlots([])
    }

    const handleShow = (dateString: string, index: number) => {
        const date = new Date(dateString.split("/").reverse().join("-"));
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        setSelectedSlots([{ ...location.bookingSlots[index], bookingDate: `${year}-${month}-${day}` }])
        setEditDate(`${day}-${month}-${year}`)
        setShow(true);
    }

    const handleOpenPaynow = () => setOpenPaynow(true);

    const handleDeleteSlot = (index: number) => {
        const filter = rescheduleSlot.filter((_: any, ind: number) => ind !== index)
        setRescheduleSlot(filter)
    }

    const GetCourt = async () => {
        const result = await GetFilterdCourt(location.facilityId, location.sportId, "true")
        if (result.statusCode == 200) {
            setCourtList(result.data.rows)
        }
    }

    useEffect(() => {
        GetCourt()
    }, [])

    const GetRescheduleAmount = async () => {
        let payload = {
            selectedSlots: rescheduleSlot.map((item) => ({ id: item.id, bookingDate: item.bookingDate, fromTime: item.fromTime, toTime: item.toTime })),
            cancelledSlots: cancelSlots,
        }
        const result = await rescheduleAmount(location.id, payload)
        if (result.status === 200) {
            setReviseAmount(result.data.data)
        } else {
            toast.error(result.response.data.message);
        }
    }

    useEffect(() => {
        if (rescheduleSlot.length > 0 || cancelSlots.length > 0) {
            GetRescheduleAmount()
        }
    }, [rescheduleSlot, cancelSlots])

    const RescheduleBooking = async () => {
        setRescheduleButton(true)
        if (paymentMethod.length > 0 || paymentMode.length > 0) {
            let payload = {
                selectedSlots: rescheduleSlot.map((item) => ({ id: item.id, bookingDate: item.bookingDate, fromTime: item.fromTime, toTime: item.toTime })),
                paymentMode: paymentMode,
                paymentMethod: paymentMethod,
                cancelledSlots: cancelSlots,
            }
            const result = await rescheduleCourtBookingApi(location.id, payload)
            if (result.status === 200) {
                setOpenPaynow(false);
                navigate("/court-booking-summary", { state: location.id })
            }
            else {
                toast.error(result.response.data.message);
            }
        }
        setRescheduleButton(false)
    }

    const handleCancelSlote = (id: number, index: number) => {
        setCancelSlots([...cancelSlots, id])
    }

    useEffect(() => {
        RescheduleBooking()
    }, [paymentMode, paymentMethod])

    const handlePayLater = () => {
        setPaymentMode("later")
        setPaymentMethod("")
    }

    const handlePayNow = () => {
        setPaymentMode("instant")
        setPaymentMethod("cash")
    }

    const handlePaymentLink = () => {
        setPaymentMode("instant")
        setPaymentMethod("online")
    }

    const getFormatedDate = (_date: string) => {
        const [_dd, _mm, _yy] = _date?.split?.("/") || [];
        return `${_mm}/${_dd}/${_yy}`;
    };

    const CheckNewAmount = location.paymentStatus === "paid" ? reviseAmount.totalAmount < reviseAmount.prevTotalAmount : location.paymentStatus === "pending" ? false : location.paymentStatus === "partially_paid" ? reviseAmount.totalAmount < reviseAmount.prevTotalPaidAmount : true

    return (
        <>
            <Container fluid className="g-0">
                <Card>
                    <Card.Body>
                        <div className="page-title align-items-center d-flex justify-content-between">
                            <Card.Title className="mb-0">Reschedule Booking</Card.Title>
                            <Button onClick={() => setShow(true)} type="button" bname="Add New Slot" name="add-slot" id="add-slot" className="btn btn-primary rounded-1"></Button>
                        </div>
                        <hr />
                        <Row className="text-start row-mb">
                            <Col lg={7}>
                                <div className="fw-semibold">Sport Name: <span className="text-info">{location.sportName}</span> </div>
                            </Col>
                            <Col lg={5}>
                                <div className="fw-semibold">Selected Court: <span className="text-info">{location.courtName}</span> </div>
                            </Col>
                        </Row>
                        <Row className="row-mb">
                            <Col lg={7}>
                                <div className="text-start">
                                    <label htmlFor="selectendtime" className="form-label">Selected Slots</label>
                                    {location.bookingSlots?.map((item: any, index: number) => {
                                        return (
                                            <Card key={item.id} className="bg-light bg-opacity-25 border-left-5 border-light mb-3">
                                                <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                                                    <div className="date-range fw-semibold">{item.bookingDate} </div>
                                                    <div className="time-slot fw-semibold">{item.fromTime} to {item.toTime}</div>
                                                    <div className="date-range fw-semibold"><span className="rupees-symbol">&#8377;</span> {item.ratePerSlot} </div>
                                                    <div className="date-range fw-semibold">{LableFromEnums(item.status, Enums)} </div>
                                                    <Button disabled={item.status !== "notStarted" || cancelSlots.includes(item.id) || CheckReschedule(`${getFormatedDate(item.bookingDate)} ${item.fromTime}`)} type="button" bname="Edit" name="Editslot" id={"edit-slot" + item.id} onClick={() => handleShow(item.bookingDate, index)} className="btn btn-sm btn-outline-primary px-4 rounded-1"></Button>
                                                    <Button disabled={item.status !== "notStarted" || cancelSlots.includes(item.id) || cancelSlots.length === 2 || (location.totalAmount <= location.totalPaidAmount && !reviseAmount.totalPayableAmount)} type="button" bname="Cancel" name="cancel-slot" id={"cancel-slot" + item.id} onClick={() => handleCancelSlote(item.id, index)} className="btn btn-sm btn-outline-primary px-4 rounded-1"></Button>
                                                </Card.Body>
                                            </Card>
                                        )
                                    })}
                                </div>
                            </Col>
                            <Col lg={5}>
                                <div className="text-start">
                                    <label htmlFor="selectendtime" className="form-label">Rescheduled Slots</label>
                                    {rescheduleSlot?.map((item: any, index: number) => {
                                        return (
                                            <Card key={"reschedule" + index} className="bg-opacity-25 bg-success border-left-5 border-opacity-50 border-success card mb-3">
                                                <Card.Body className="align-items-center card-body d-flex justify-content-between p-2">
                                                    <div className="date-range fw-semibold">{item.bookingDate?.split("-").reverse().join("/")} </div>
                                                    <div className="time-slot fw-semibold">{item.fromTime} to {item.toTime}</div>
                                                    <Button onClick={() => handleDeleteSlot(index)} type="button" bname="Delete" name="deleteslot" id="deleteslot" className="btn btn-sm btn-outline-danger px-4 rounded-1"></Button>
                                                </Card.Body>
                                            </Card>
                                        )
                                    })}
                                </div>
                            </Col>
                        </Row>
                        <Row className="text-end">
                            <hr />
                            <Col md={{ span: 4, offset: 8 }}>
                                <span className="user-info-title text-info text-uppercase mb-2">Reschedule Slot Amount: </span>
                                <span className="user-info"><span className="rupees-symbol">&#8377;</span> {rescheduleSlot.length ? reviseAmount.totalAmount?.toFixed(2) : "0.00"}</span>
                            </Col>

                            {(location.discount !== undefined) &&
                                <Col md={{ span: 4, offset: 8 }}>
                                    <span className="user-info-title text-info text-uppercase mb-2">Discount: </span>
                                    <span className="user-info"><span className="rupees-symbol">&#8377;</span> {location.discount?.toFixed(2)}</span>
                                </Col>}
                            <Col md={{ span: 4, offset: 8 }}>
                                <span className="user-info-title text-info text-uppercase mb-2">Previous Billing Amount: </span>
                                <span className="user-info"><span className="rupees-symbol">&#8377;</span> {reviseAmount.prevTotalAmount ? reviseAmount.prevTotalAmount?.toFixed(2) : location.totalAmount?.toFixed(2)}</span>
                            </Col>
                            <Col md={{ span: 4, offset: 8 }}>
                                <span className="user-info-title text-info text-uppercase mb-2">Already Paid: </span>
                                <span className="user-info"><span className="rupees-symbol">&#8377;</span> {reviseAmount.prevTotalPaidAmount ? reviseAmount.prevTotalPaidAmount?.toFixed(2) : location.totalPaidAmount?.toFixed(2)}</span>
                            </Col>
                            <Col md={{ span: 5, offset: 7 }}>
                                <span className="user-info-title text-info text-uppercase mb-2">Revised Amount Need to Collect: </span>
                                <span className="user-info"><span className="rupees-symbol">&#8377;</span> {(rescheduleSlot.length || cancelSlots.length) ? reviseAmount.totalPayableAmount?.toFixed(2) : (location.totalAmount - location.totalPaidAmount).toFixed(2)}</span>
                            </Col>
                        </Row>
                        {CheckNewAmount && <span className="error-msg">Reschedule Amount  Must EQUAL or MORE Than Privious Amount</span>}
                        <hr />
                        <Row className="text-end">
                            {(rescheduleSlot.length !== 0 || cancelSlots.length !== 0) &&
                                <Col lg={12}>
                                    {reviseAmount.totalPayableAmount == 0 ?
                                        <Button disabled={rescheduleButton} onClick={handlePayNow} type="button" bname={rescheduleButton ? "Confirming..." : "Confirm"} name="confirm" id="confirm" className="btn btn-primary rounded-1 me-3"></Button>
                                        :
                                        <>
                                            <Button disabled={CheckNewAmount || rescheduleButton} onClick={handleOpenPaynow} type="button" bname="Pay Now" name="paynow" id="paynow" className="btn btn-primary rounded-1 me-3"></Button>
                                            {name === "SUPER_ADMIN" && <Button disabled={CheckNewAmount || rescheduleButton} onClick={handlePayLater} type="button" bname={rescheduleButton ? "Confirming..." : "Pay Later"} name="paylater" id="paylater" className="btn btn-outline-primary rounded-1"></Button>}
                                        </>
                                    }
                                </Col>}
                        </Row>
                    </Card.Body>
                </Card>
            </Container>
            <CalendarModal show={show} handleClose={handleClose} setSelectedSlots={setSelectedSlots} selectedSlots={selectedSlots} slotDate={editDate} courtId={location.courtId} reschedule={true} setRescheduleSlot={setRescheduleSlot} rescheduleSlot={rescheduleSlot} forBooking={"Reschedule_Booking"} maxPreBookingDay={courtList.find((item: any) => item.id == location.courtId)?.rescheduleMaxDays} />

            <Modal show={openPaynow} onHide={handleClose} centered>
                <Modal.Header className="border-0 pb-0 pb-2" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter fw-semibold">Payment Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-4">
                        <Col >
                            <Button disabled={rescheduleButton} onClick={handlePayNow} type="button" bname={rescheduleButton ? "Cash Collected" : "Collect Cash"} name="collect-cash" id="collect-cash" className="btn btn-outline-danger btn-sm mt-1 px-4 rounded-1"></Button>
                        </Col>
                        <Col className="text-end">
                            <Button disabled={rescheduleButton} onClick={handlePaymentLink} type="button" bname={rescheduleButton ? "Payment link Shared" : "Share Payment link"} name="share-payment-link" id="share-payment-link" className="btn btn-link btn-sm mt-1 px-4 rounded-1"></Button>
                        </Col>
                    </Row>

                </Modal.Body>
            </Modal>
            <ToastContainer />
        </>
    )
}
export { RescheduleCourtBooking }
